import { twMerge } from 'tailwind-merge';

import { backgroundColors, threeLetterResourceMap } from '../dag/resourceConstants';
import { DbtResourceIcon, ResourceTypeExplorer } from './ResourceTypeIcon';

type LensResourceIconDisplayProps = Omit<LensResourceIconProps, 'isSelected'> & {
  showColor: boolean;
};

const LensResourceIconDisplay = ({
  resourceType,
  showColor,
  className,
}: LensResourceIconDisplayProps) => {
  const textClass = showColor ? 'text-fgBlack' : 'text-fgMain';
  return (
    <div
      className={twMerge(
        className,
        'text-center',
        showColor && backgroundColors[resourceType],
        !showColor && 'bg-bgNeutralMuted',
      )}
      data-resource-icon-show-color={showColor}
    >
      <DbtResourceIcon
        resource={resourceType}
        className={twMerge('mb-1.5 mt-1.5 w-full', textClass)}
      />
      <div
        className={twMerge(
          '-mt-1 w-full text-center align-top font-mono text-xs',
          textClass,
        )}
      >
        {threeLetterResourceMap[resourceType]}
      </div>
    </div>
  );
};

type LensResourceIconProps = {
  resourceType: ResourceTypeExplorer | 'unknown';
  isSelected: boolean;
  className?: string;
  showColor: boolean;
};

export const LensResourceIcon = ({
  className,
  resourceType,
  showColor,
}: LensResourceIconProps) => {
  return (
    <LensResourceIconDisplay
      className={className}
      resourceType={resourceType}
      showColor={showColor}
    />
  );
};
